import { EOtherAsset } from '~config/types';

import { useContractChainlinkOracles } from '../contracts';

export const useAllChainlinkContracts = () => {
  const BALChainlinkContract = useContractChainlinkOracles(EOtherAsset.BAL);
  const DAIChainlinkContract = useContractChainlinkOracles(EOtherAsset.DAI);
  const FRAXChainlinkContract = useContractChainlinkOracles(EOtherAsset.FRAX);
  const FXSChainlinkContract = useContractChainlinkOracles(EOtherAsset.FXS);
  const USDCChainlinkContract = useContractChainlinkOracles(EOtherAsset.USDC);
  const USDTChainlinkContract = useContractChainlinkOracles(EOtherAsset.USDT);

  return {
    [EOtherAsset.BAL]: BALChainlinkContract,
    [EOtherAsset.DAI]: DAIChainlinkContract,
    [EOtherAsset.FRAX]: FRAXChainlinkContract,
    [EOtherAsset.FXS]: FXSChainlinkContract,
    [EOtherAsset.USDC]: USDCChainlinkContract,
    [EOtherAsset.USDT]: USDTChainlinkContract,
  };
};
